import { useNavigate } from 'react-router-dom';
import "./TopMenu.css";

export const TopMenuEmpty = ({ 
}) => {
  const navigate = useNavigate();

  const gotoMain = () => {
    navigate('/');
  };


  return (
    <div className="top-menu">
      <img 
        className="top-menu__logo-image" 
        src="icons/yournest_horizontal_logo.svg" 
        onClick={gotoMain}
      />
    </div>
  );
};